import React, { Component } from "react";

const CustomerActivityCard = props => {
  const { customerName, data } = props;
  return(
    <div style={{ backgroundColor: "#f7f7f7", padding: "20px", borderRadius: "0.5rem", height: "200px" }}>
      <h5 className="text-center mb-1">{customerName}</h5>
      {
        data.length
        ? data.map((item, index) => {
          return(
            <div key={index} className="d-flex justify-content-between align-items-center">
              <p className="text-capitalize mb-0">{item.title}</p>
              <p>{item.value}</p>
            </div>
          )
        })
        :null
      }
    </div>
  )
} 

export default CustomerActivityCard;